export default __webpack_public_path__ + "static/media/homepage-1.3081df4a.jpg";